import { defineMessages } from 'react-intl';

export default defineMessages({
    accountSummary: {
        id: 'portal.views.home-page-layout.Account Summary',
        defaultMessage: 'Account Summary',
    },
    myBalance: {
        id: 'portal.directives.templates.billing-summary-tiles.My Balance',
        defaultMessage: 'My Balance',
    },
    overdue: {
        id: 'portal.directives.templates.billing-summary-tiles.Overdue',
        defaultMessage: 'Overdue',
    },
    payNow: {
        id: 'portal.directives.templates.billing-summary-tiles.Pay Now',
        defaultMessage: 'Pay Now',
    },
    myNextBill: {
        id: 'portal.directives.templates.billing-summary-tiles.My Next Bill',
        defaultMessage: 'My Next Bill'
    },
    due: {
        id: 'portal.directives.templates.billing-summary-tiles.Due',
        defaultMessage: 'Due',
    },
    updateMyDetails: {
        id: 'portal.views.home-page-layout.My Account Details',
        defaultMessage: 'My Account Details'
    },
    lastPayment: {
        id: 'portal.directives.templates.billing-summary-tiles.My Last Payment',
        defaultMessage: 'My Last Payment',
    },
    paid: {
        id: 'portal.directives.templates.billing-summary-tiles.Paid',
        defaultMessage: 'Paid',
    },
    renewalInfo: {
        id: 'portal.views.home-page-layout.You have policies due for renewal.',
        defaultMessage: 'You have policies due for renewal.'
    },
    policies: {
        id: 'portal.views.home-page-layout.Policies',
        defaultMessage: 'Policies'
    },
    type: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.type',
        defaultMessage: 'Type'
    },
    statusActive: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Active',
        defaultMessage: 'Active'
    },
    statusExpired: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Expired',
        defaultMessage: 'Expired'
    },
    statusOffered: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Offered',
        defaultMessage: 'Offered'
    },
    status: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.status',
        defaultMessage: 'Status'
    },
    policy: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Policy',
        defaultMessage: 'Policy'
    },
    effective: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.effective',
        defaultMessage: 'Term Effective Period'
    },
    premium: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.premium',
        defaultMessage: 'Premium'
    },
    myQuickLinks: {
        id: 'portal.views.home-page-layout.My Quick Links',
        defaultMessage: 'My Quick Links'
    },
    printanIDCard: {
        id: 'portal.views.home-page-layout.Print an ID Card',
        defaultMessage: 'Print an ID Card'
    },
    makeAPayment: {
        id: 'portal.views.home-page-layout.Make a Payment',
        defaultMessage: 'Make a Payment'
    },
    setupAutomaticPayments: {
        id: 'portal.views.home-page-layout.Setup Automatic Payments',
        defaultMessage: 'Setup Automatic Payments'
    },
    changeMyPolicy: {
        id: 'portal.views.home-page-layout.ChangeMyPolicy',
        defaultMessage: 'Change My Policy'
    },
    fileClaim: {
        id: 'portal.views.home-page-layout.FileClaim',
        defaultMessage: 'File a Claim'
    },
    getAPersonalAutoQuote: {
        id: 'portal.views.home-page-layout.Get a Personal Auto Quote',
        defaultMessage: 'Get a Personal Auto Quote'
    },
    getAHomeOwnersQuote: {
        id: 'portal.views.home-page-layout.Get a Home Owners Quote',
        defaultMessage: 'Get a Home Owners Quote'
    },
    policyDetailsAgent: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.agent',
        defaultMessage: 'Agent'
    },
    policyDetailsIdCard: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.id card',
        defaultMessage: 'ID Card'
    },
    policyDetailsFileClaim: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.fileClaim',
        defaultMessage: 'File a Claim'
    },
    myBalanceTileCurrent: {
        id: 'portal.directives.templates.billing-summary-tiles.Current',
        defaultMessage: 'Current'
    },
    policyNotShowing: {
        id: 'portal.views.home-page-layout.Do you have a policy with us but it is not showing?',
        defaultMessage: 'Do you have a policy with us but it is not showing?'
    },
    addPolicy: {
        id: 'portal.views.home-page-layout.Add Policy',
        defaultMessage: 'Add Policy'
    },
    totalPremium: {
        id: 'tdic.portal.directives.templates.billing-summary-tiles.Total Premium',
        defaultMessage: 'Total Premium',
    },
    totalPremiumExcludingSurcharges: {
        id: 'tdic.portal.directives.templates.billing-summary-tiles.Premium Excl. Surcharges',
        defaultMessage: 'Premium Excl. Surcharges',
    },
    remainingBalance: {
        id: 'tdic.portal.directives.templates.billing-summary-tiles.Remaining Balance',
        defaultMessage: 'Remaining Balance',
    },
    nextDueDate: {
        id: 'tdic.portal.directives.templates.billing-summary-tiles.Next Due Date',
        defaultMessage: 'Next Due Date',
    },
    lastPaidDate: {
        id: 'tdic.portal.directives.templates.billing-summary-tiles.Last Paid Date',
        defaultMessage: 'Last Paid Date',
    },
    APWEnrolled: {
        id: 'tdic.policy.common.directives.templates.policy-account-policy-summaries.Autopay',
        defaultMessage: 'Autopay'
    },
    currentDue: {
        id: 'tdic.portal.directives.templates.billing-summary-tiles.Current Due',
        defaultMessage: 'Current Due'
    },
    pastDue: {
        id: 'tdic.portal.directives.templates.billing-summary-tiles.Past Due',
        defaultMessage: 'Past Due'
    },
    requestAQuote: {
        id: 'tdic.portal.views.home-page-layout.Request a Quote',
        defaultMessage: 'Request a Quote'
    },
    changePaymentPlan: {
        id: 'tdic.portal.views.home-page-layout.Change Payment Plan',
        defaultMessage: 'Change Payment Plan'
    },
    managePaymentPlan: {
        id: 'tdic.portal.views.home-page-layout.Manage Payment Plan',
        defaultMessage: 'Manage Payment Plan'
    },
    delinquencyStatusMsg: {
        id: 'tdic.portal.views.home-page-layout.delinquencyStatusMsg. Your account is past due. To avoid a lapse in coverage, select',
        defaultMessage: 'Your account is past due. To avoid a lapse in coverage, select {link} and follow the prompts to pay the balance due.'
    },
    delinquencyStatus: {
        id: 'tdic.portal.views.home-page-layout.delinquencyStatus.TransactionConfirmation.Policy Billing Page',
        defaultMessage: 'Pay My Bill'
    },
    payMyBill: {
        id: 'tdic.portal.views.home-page-layout,.payMyBill.Pay My Bill',
        defaultMessage: 'Pay My Bill'
    },
    noPoliciesAvailable: {
        id: 'tdic.portal.views.home-page-layout.no policy data',
        defaultMessage: 'No Policies available at this time'
    },
    policyNumber: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Number',
        defaultMessage: 'Number'
    },
    termEffective: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Term Effective',
        defaultMessage: 'Term Effective'
    },
    turnOn: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Turn On',
        defaultMessage: 'Turn On'
    },
    setUp: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Set Up',
        defaultMessage: 'Set Up'
    },
    declarationPagePrintColumn: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Declaration Page',
        defaultMessage: 'Declaration Page'
    },
    CanNotLoadYourPolicyAtThisTime: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.Sorry we can not load your policy information at this time',
        defaultMessage: 'Sorry we can not load your policy information at this time'
    },
    policyRequestFailed: {
        id: 'policy.common.directives.templates.policy-account-policy-summaries.ERROR',
        defaultMessage: 'ERROR'
    }

});
